import { useEffect, useState } from 'react';

const BANNER =
  'sk:fixed sk:left-0 sk:top-0 sk:z-1200 sk:flex sk:w-full sk:justify-center sk:p-1.25 sk:text-sm sk:font-medium sk:text-surface';

export function InternetCheck() {
  const [isOnline, setIsOnline] = useState(true);
  const [firstTime, setFirstTime] = useState(true);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setFirstTime(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (firstTime) {
    return null;
  }

  /* The keyframes live in styles.css. */
  if (!isOnline) {
    return (
      <div
        role="status"
        className={`${BANNER} sk:bg-danger sk:animate-[sk-banner-show_0.6s_linear_forwards]`}
      >
        No Internet Connection
      </div>
    );
  }

  return (
    <div
      role="status"
      className={`${BANNER} sk:bg-success sk:animate-[sk-banner-hide_1.5s_linear_forwards]`}
    >
      Back Online!
    </div>
  );
}
